<template>
  <div>
    <lk-card>
      <p slot="title">
        <span class="mr8">{{notPrescription ? '订单信息' : '处方信息'}}</span>
        <lk-button
          size='small'
          type='text'
          v-if="!notPrescription && showLink"
          style="color: #0099ff"
          @click='connectDprescription'
          :disabled='!able || isTmall'
        >关联电子处方</lk-button>
      </p>
      <div ref="prescriptionPart" class="prescription-page">
        <lk-form ref="prescription" :label-width="95" :rules='salePrescription' :model='info'>
          <div v-if="!notPrescription">
            <lk-row :gutter='16'>
              <lk-col span='11'>
                <lk-form-item label="处方医生:" prop="prescriptionDoctor" ref="prescriptionDoctor"
                  :class="{'ivu-form-item-required':isDataLinkRx}">
                  <!-- <lk-input v-if='able' :maxlength='30' ref="prescription2" placeholder='请输入'
                    v-model="info.prescriptionDoctor ">
                  </lk-input> -->
                  <lk-auto-complete
                    v-if="able"
                    :clearable='true'
                    :maxlength="30"
                    ref="prescription2"
                    v-model="info.prescriptionDoctor"
                    @on-change="handleSearch1"
                    @on-select='handleSelect'
                    @on-focus='handleFoucus'
                    placeholder="可通过医生姓名搜索"
                    >
                    <div class="test1" v-if='doctorList'>
                      <lk-option v-for="(item,index) in doctorList" :value="item.doctorCode" :key="index">{{`${item.doctorName}-${item.hospitalName}-${item.deptName}`}}</lk-option>
                    </div>
                    <div v-else>
                        <div v-if="isEmpty" class="nodata">
                          暂无数据
                        </div>
                      </div>
                  </lk-auto-complete>

                  <span v-else>{{info.prescriptionDoctor}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='11' >
                <lk-form-item label="处方医院:" prop="prescriptionHospital" ref="prescriptionHospital"
                  :class="{'ivu-form-item-required':isDataLinkRx}">
                  <prescriptionHospital v-if='able' :maxlength='100'  placeholder='请输入'
                    v-model="info.prescriptionHospital"></prescriptionHospital>
                  <span v-else>{{info.prescriptionHospital}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='11' >
                <lk-form-item label="科室:" prop="hospitalDept">
                  <lk-input v-if='(isEdit && isIncludes("hospitalDept")) || isTmall || isMeiXin' :maxlength='20' ref="prescription5" placeholder='请输入'
                    v-model="info.hospitalDept"></lk-input>
                  <span v-else>{{info.hospitalDept}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='11'>
                <lk-form-item label="处方单号:" prop="prescriptionNo">
                  <lk-input v-if='(isEdit && isIncludes("prescriptionNo")) || isTmall || isMeiXin' :maxlength='20' ref="prescription0" placeholder='请输入'
                    v-model="info.prescriptionNo "></lk-input>
                  <span v-else>{{info.prescriptionNo}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
               <lk-col span='11'>
                <lk-form-item label="处方时间:" prop="prescriptionTime">
                  <timeStampDatePicker style="width:100%" ref="prescription4" placeholder='请选择'
                    v-if='(isEdit && isIncludes("prescriptionTime")) || isTmall || isMeiXin' v-model="info.prescriptionTime "></timeStampDatePicker>
                  <span v-else>{{info.prescriptionTime|formatDate}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='11'>
                <lk-form-item label="问诊医生:" prop="inquiryDoctor">
                  <lk-input v-if='(isEdit && isIncludes("inquiryDoctor")) || isTmall || isMeiXin' :maxlength='100' placeholder='请输入'
                    v-model="info.inquiryDoctor"></lk-input>
                  <span v-else>{{info.inquiryDoctor}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
               <lk-col span='11'>
                 <lk-form-item label="问诊医院:" prop="inquiryHospital">
                  <lk-input v-if='(isEdit && isIncludes("inquiryHospital")) || isTmall || isMeiXin' :maxlength='100' ref="prescription12" placeholder='请输入'
                    v-model="info.inquiryHospital "></lk-input>
                  <span v-else>{{info.inquiryHospital}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='11'>
                <lk-form-item label="联系人:" prop="contact">
                  <lk-input v-if='(isEdit && isIncludes("contact")) || isTmall || isMeiXin' :maxlength='100' placeholder='请输入' v-model="info.contact">
                  </lk-input>
                  <span v-else>{{info.contact}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='11'>
                <lk-form-item label="联系人电话:" prop="contactPhone">
                  <lk-input v-if='(isEdit && isIncludes("contactPhone")) || isTmall || isMeiXin' :maxlength='20' placeholder='请输入' v-model="info.contactPhone">
                  </lk-input>
                  <span v-else>{{info.contactPhone}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-divider class="divider"/>
              <lk-row :gutter='16' v-if='false'>
              <lk-col span='18'>
                <lk-form-item label="患者检索:">
                  <prescriptionSearch @selected='importPresription' :type='type'>
                  </prescriptionSearch>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='11'>
                <lk-form-item label="患者姓名:" prop="patientName" ref="patientName">
                  <lk-input v-if='(isEdit && isIncludes("patientName")) || isTmall || isMeiXin' :maxlength='32' ref="prescription6" placeholder='请输入'
                    v-model="info.patientName"></lk-input>
                  <span v-else>{{info.patientName}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='11'>
                <lk-form-item label="患者性别:" prop="patientGender">
                  <lk-radio-group ref="prescription9" v-if='isEdit || isTmall || isMeiXin' v-model="info.patientGender">
                    <lk-radio v-for="(item,index) in genderList" :label="index*1" :key="index">
                      <span>{{item}}</span>
                    </lk-radio>
                  </lk-radio-group>
                  <span v-else>{{genderList[info.patientGender]}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col span='11'>
                <lk-form-item label="患者年龄:" prop="patientAge">
                  <numberInput  :maxlength='4' ref="prescription10" v-if='(isEdit && isIncludes("patientAge")) || isTmall || isMeiXin'
                    type='int' size='default' placeholder='请输入' v-model="info.patientAge"></numberInput>
                  <span v-else>{{info.patientAge}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='11'>
                <lk-form-item label="证件号码:" prop="patientIdCard">
                  <!-- <lk-input v-if='able' :maxlength='30' ref="prescription8" placeholder='请输入'
                    v-model="info.patientIdCard ">
                  </lk-input> -->
                    <CredentialsInput :able='isEdit || isTmall || isMeiXin' v-model.trim='info' @setRules='setRules'></CredentialsInput>
                  <!-- <span v-else>{{info.patientIdCard}}</span> -->
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
              <lk-col :span='23'>
                <lk-form-item label='患者地址:'>
                  <div class="editRow" v-if='isEdit || isTmall || isMeiXin'>
                    <location style="width:40%" v-model="info.locationArr" @on-change="changeLocation"></location>
                    <lk-input style="width:60%" v-model="info.address"></lk-input>
                  </div>
                  <div v-else>
                    <span>{{info.locationString}}</span>&nbsp;
                    <span>{{info.address}}</span>
                  </div>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row :gutter='16'>
               <lk-col span='11'>
                <lk-form-item label="联系方式:" prop="patientPhone" ref="patientPhone">
                  <lk-input v-if='(isEdit && isIncludes("patientPhone")) || isTmall || isMeiXin' :maxlength='50' ref="prescription7" placeholder='请输入'
                    v-model="info.patientPhone "></lk-input>
                  <span v-else>{{info.patientPhone}}</span>
                </lk-form-item>
              </lk-col>
              <lk-col span='11'>
                <lk-form-item label="诊断说明:" prop="diseaseId" ref="diseaseId"
                  :class="{'ivu-form-item-required':isDataLinkRx}">

                  <lk-select ref="prescription3"
                             @on-keydown='handleHotKey($event,"prescription3")'
                             v-if='able'
                             filterable
                             v-model="info.diseaseId"
                             @on-change='setAdditionalRemark'
                             clearable>
                    <lk-option v-for="(item,index) in diseaseList" :key="index" :value='item.id'>{{item.diseaseName}}</lk-option>

                  </lk-select>
                  <span v-else>{{info.diseaseName}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
            <lk-row>
              <lk-col span='18'>
                <lk-form-item label="诊断补充说明:" prop="additionalRemark" ref="additionalRemark"
                  :class="{'ivu-form-item-required':info.diseaseName==='其他'&& this.able}">
                  <lk-input v-if='able' :maxlength='100' ref="prescription11" placeholder='请输入'
                    v-model="info.additionalRemark "></lk-input>
                  <span v-else>{{info.additionalRemark}}</span>
                </lk-form-item>
              </lk-col>
            </lk-row>
          </div>
          <lk-divider v-if="!notPrescription"/>
          <lk-row :gutter='16'>
            <lk-col span='23'>
              <lk-form-item :label="notPrescription?'商品明细:':'处方商品:'" prop="name">
<lk-button v-if="false" class="mb8" type='primary' @click="$emit('handlePrescriptionGoods',true)">编辑处方商品</lk-button>


                <div class="goodsTable" v-if="showGoodsTable">

                  <table>
                    <thead>
                      <tr>

                        <td>商品通用名</td>
                        <td>商品名</td>
                        <td v-if="showSpec">规格</td>
                        <td>购买数量</td>
                        <td>用法</td>
                        <td>频次</td>
                        <td>每次用量</td>
                        <td>开始用药时间</td>
                        <td>用药周期</td>
                        <td>用药提醒天数</td>

                      </tr>
                    </thead>
                    <tbody v-if='info.saleUsageList&&info.saleUsageList.length'>
                      <template v-for="(item,index) in info.saleUsageList">
                        <tr :key="index">


                          <td>{{item.approvedDrugNames||item.approvedDrugName}}</td>
                          <td>{{item.goodsName||item.approvedDrugName}}</td>
                          <td v-if="showSpec">{{item.spec}}</td>
                          <td>{{item.goodsCount}}</td>
                          <td>
                            <select-input v-if="prescriptionEdit" size='small'
                              v-model="info.saleUsageList[index].goodsUsageType"
                              :otherStr='info.saleUsageList[index].goodsUsage'
                              :options='baseData.usageArr' name='dictionaryName' keyName='dictionaryIndex'
                              @setOther='val=>{info.saleUsageList[index].goodsUsage=val}'>
                            </select-input>
                            <span
                              v-else>{{info.saleUsageList[index].goodsUsage||
                              exchangeDictionary(baseData.usageArr,info.saleUsageList[index].goodsUsageType)
                            }}</span>


                          </td>
                          <td>
                            <select-input v-if="prescriptionEdit" v-model="info.saleUsageList[index].frequency"
                              :otherStr='info.saleUsageList[index].frequencyName'  size='small'
                              :options='baseData.frequencyArr' name='dictionaryName' keyName='dictionaryIndex'
                              @setOther='val=>{info.saleUsageList[index].frequencyName=val}'>
                            </select-input>
                            <span
                              v-else-if='info.saleUsageList[index].frequency||info.saleUsageList[index].frequencyName'>{{info.saleUsageList[index].frequencyName||
                               exchangeDictionary(baseData.frequencyArr,info.saleUsageList[index].frequency||info.saleUsageList[index].frequencyName)}}</span>

                          </td>
                          <td>
                            <lk-input v-if='prescriptionEdit' size='small' :maxlength='20'
                              :ref='`prescription${14 + index * 5}`' placeholder='请输入'
                              v-model="info.saleUsageList[index].goodsDosage ">
                            </lk-input>

                            <span v-else>{{info.saleUsageList[index].goodsDosage}}</span>

                          </td>
                          <td>
                            <timeStampDatePicker style='width:100%' size='small' v-if='prescriptionEdit'
                              :ref='`prescription${15 + index * 5}`' placeholder='请输入'
                              v-model="info.saleUsageList[index].usageStartTime ">
                            </timeStampDatePicker>
                            <span
                              v-else>{{info.saleUsageList[index].usageStartTime |formatDate}}</span>
                          </td>
                          <td>
                            <lk-input-number style='width:100%'
                              v-model="info.saleUsageList[index].medicationCycle" :min='0'
                              size='small' v-if='prescriptionEdit' :maxlength='10'></lk-input-number>
                            <span v-else>{{info.saleUsageList[index].medicationCycle}}</span>
                          </td>
                          <td>
                            <lk-input-number style='width:100%'
                              v-model="info.saleUsageList[index].rebuyRemindDays" :min='0'
                              size='small' v-if='prescriptionEdit' :maxlength='10'></lk-input-number>
                            <span v-else>{{info.saleUsageList[index].rebuyRemindDays}}</span>
                          </td>
                        </tr>
                      </template>
                    </tbody>
                  </table>
                </div>
              </lk-form-item>
            </lk-col>
          </lk-row>
          <lk-row :gutter='16' v-if="!notPrescription">
            <lk-col span='11'>
              <lk-form-item label="调配人:" prop="allocater">
                <lk-select :ref='"prescription-2"' placeholder='请输入' v-if='able||ablePharmacistList'
                  @on-change='exchangePharmacistList(info.allocater,"allocaterName")'
                  v-model="info.allocater " filterable>
                  <lk-option v-for="(item, index) in pharmacistList"
                  :key="index"
                  :value='item.id'>{{item.name}}</lk-option>
                </lk-select>
                <span v-else>{{info.allocaterName}}</span>
              </lk-form-item>
            </lk-col>
            <lk-col span='11' >
              <lk-form-item label="复核人:" prop="reviewer">
                <lk-select :ref='"prescription-1"' v-model="info.reviewer " v-if='able||ablePharmacistList'
                  @on-change='exchangePharmacistList(info.reviewer,"reviewerName")'
                  placeholder='请输入' filterable>

                  <lk-option v-for="(item, index) in pharmacistList"
                  :key="index"
                  :value='item.id'>{{item.name}}</lk-option>
                </lk-select>

                <span v-else>{{info.reviewerName}}</span>
              </lk-form-item>
             </lk-col>
          </lk-row>
        </lk-form>
      </div>
      <div class="image-container" v-if="!notPrescription">
        <prescriptionImage
          :able='true'
          v-model="info.picUrls"
          :url="info.picUrls"
          :sourceType="info.sourceType"
          :orderType="info.type"
          :isAbleUpload='isAbleUpload'
        />
      </div>
    </lk-card>
    <lk-modal
      v-model="modalPre"
      :footer-hide='true'
      title="关联电子处方">
      <lk-form :model='preInfo' :rules='preInfoRules' :label-width="80" ref="preInfoForm" v-if="modalPre">
        <lk-form-item label='互联网医院:'>
          <span>银川零氪互联网医院</span>
        </lk-form-item>
        <lk-form-item label='处方单号:' prop='code'>
          <lk-input :maxlength='20' placeholder='请输入处方单号' v-model="preInfo.code "></lk-input>
        </lk-form-item>
        <lk-form-item label='患者姓名:' prop="patientName">
          <lk-input :maxlength='20' placeholder='请输入患者姓名' v-model="preInfo.patientName"></lk-input>
        </lk-form-item>
      </lk-form>
      <div class="btnCon">
        <lk-button size='small' type='primary' @click='connect' :disabled='btnConnectSta'>查询</lk-button>
        <lk-button size='small' @click='cancel' style="margin-left:10px">取消</lk-button>
      </div>
    </lk-modal>
    <lk-card title="联系人信息" v-if="notPrescription" style="margin-top:10px">
      <lk-row>
        <lk-col>
          <div style="display:flex">
            <div>联系人:</div>
            <div>{{info.contact || ''}}</div>
          </div>
        </lk-col>
      </lk-row>
    </lk-card>
  </div>
</template>
<script>
import timeStampDatePicker from '../timeStampDatePicker.vue';
import utils from '../../libs/utils.js';
import prescriptionSearch from './PatientSearch.vue';
import prescriptionHospital from './PrescriptionHospital.vue';
import goods from '../../services/goods';
import SelectInput from '../selectInput.vue';
import CredentialsInput from '../CredentialsInput';
import prescriptionImage from '../sale/Image';
import mapState from '../../mixins/mapState';
import location from '../location.vue';

export default {
  name: 'prescriptionCommon',
  mixins: [mapState],
  components: {
    timeStampDatePicker,
    prescriptionSearch,
    SelectInput,
    prescriptionHospital,
    CredentialsInput,
    prescriptionImage,
    location,
  },
  props: {
    able: {
      type: Boolean,
      default: false,
    },
    isPrescription: {
      type: Boolean,
    },
    isContainDataDirectGoods: {
      type: Boolean,
    },
    isDataLinkRx: {
      type: Boolean,
      default: false,
    },
    isPatientRebuy: {
      type: Boolean,
      default: false,
    },
    data: {
      type: Object,
    },
    pharmacistList: {
      type: Array,

    },
    ablePharmacistList: {
      default: false,
    },
    showSpec: {// 是否显示商品规格
      default: true,
    },
    saleOrderDetailList: {
      type: Array,
    },
    type: {},
    diseaseList: { type: Array, default: () => [] },
    multiple: {
      default: false,
    },
    dataLink: {
      type: Boolean,
      default: false,
    },
    showLink: {
      type: Boolean,
      default: true,
    },
  },
  model: {
    prop: 'data',
    event: 'change',
  },
  computed: {
    notPrescription() {
      return this.info.type === 2 || this.info.type === 6;
    },
    isEdit() {
      return this.data.type === 5 || [10, 13].indexOf(this.info.sourceType) >= 0; // 预约处方订单或者天猫
    },
    prescriptionEdit() {
      if (this.isMeiXin) {
        return true;
      }
      const edit = this.isPatientRebuy && [10, 13].indexOf(this.info.sourceType) >= 0;
      this.setRemark(edit); // 天猫的复购药才进行患者姓名和联系方式必填校验
      return edit;
    },
    isTmall() { // 10 天猫 13京东
      return [10, 13].indexOf(this.info.sourceType) >= 0;
    },
    isMeiXin() {
      return this.info.sourceType === 12 && this.able;
    },
  },
  watch: {
    data: {
      handler() {
        this.info = this.data;
      },
      deep: true,
    },
    info: {
      handler() {
        this.able && this.info.saleUsageList.forEach((item) => { // 处理输入问题，后续考虑其他方式解决
          item.medicationCycle || (item.medicationCycle = null);
          item.rebuyRemindDays || (item.rebuyRemindDays = null);
        });
        // this.$emit('change', this.info);
      },
      deep: true,
    },
    dataLink: {
      handler(e) {
        if (e && this.able) {
          this.salePrescription.prescriptionDoctor = { required: true, message: '请输入患者姓名', trigger: 'blur' };
          this.salePrescription.prescriptionHospital = { required: true, message: '请输入处方医院', trigger: 'blur' };
          this.salePrescription.diseaseId = {
            required: true, message: '请选择诊断说明', trigger: 'change', type: 'number',
          };
          this.$refs.prescriptionDoctor.isRequired = true;
          this.$refs.prescriptionHospital.isRequired = true;
          this.$refs.diseaseId.isRequired = true;
          this.setAdditionalRemark();
        }
      },
    },
  },
  data() {
    return {
      JTBLEditList: [],
      btnConnectSta: false,
      modalPre: false,
      preInfo: {
        code: null,
        patientName: null,
      },
      isAbleUpload: false, // 是否可以重新上传
      isEmpty: false,
      selectStatus: false,
      doctorList: [],
      genderList: {
        1: '男',
        2: '女',
      },
      showGoodsTable: true,
      baseData: {},
      isValidated: false,
      info: {
        patientIdCard: '',
        permissionType: null,
        saleUsageList: [],
      },
      salePrescription: {

      },
      preInfoRules: {
        code: [
          {
            required: true,
            message: '请输入处方单号',
            trigger: 'change',
          },
        ],
        patientName: [
          {
            required: true,
            message: '请输入患者姓名',
            trigger: 'change',
          },
        ],
      },
    };
  },
  methods: {
    changeLocation(val) {
      if (val) {
        this.info.provinceId = val[0];
        this.info.cityId = val[1];
        this.info.countyId = val[2];
      }
    },
    isIncludes(key) {
      return this.JTBLEditList.includes(key);
    },
    setRemark(edit) {
      if (!this.notPrescription) {
        if (edit) {
          this.salePrescription.patientName = [
            { required: true, message: '请输入患者姓名', trigger: 'blur' },
          ];
          this.salePrescription.patientPhone && this.salePrescription.patientPhone.push({ required: true, message: '请输入联系方式', trigger: 'blur' });
          this.$refs.patientName.isRequired = true;
          this.$refs.patientPhone.isRequired = true;
        } else {
          this.salePrescription.patientName = [];
          this.salePrescription.patientPhone = this.salePrescription.patientPhone && this.salePrescription.patientPhone.filter(item => !item.required);
          this.$nextTick(() => {
            this.$refs.patientName.isRequired = false;
            this.$refs.patientPhone.isRequired = false;
            this.$refs.patientName.validateMessage = '';
            this.$refs.patientName.validateState = '';
            this.$refs.patientPhone.validateMessage = '';
            this.$refs.patientPhone.validateState = '';
          });
        }
      }
    },
    connect() {
      this.$refs.preInfoForm.validate((valid) => {
        if (valid) {
          const list = [];
          this.saleOrderDetailList.forEach((item) => {
            if (item && item.isRx === 1) { // 1-处方药，2-非处方药
              list.push({ goodsBaseId: item.goodsBaseId, num: item.goodsCount });
            }
          });
          const params = {
            code: this.preInfo.code,
            patientName: this.preInfo.patientName,
            detailList: list,
            epId: this.info.id,
          };
          this.btnConnectSta = true;
          goods.getElectronicInfoByCode(params).then((res) => {
            if (res.data.status === 200) {
              this.$Message.success('查询成功');
              const temp = res.data.data.prescription;
              this.info.isConnectElePre = true;
              this.info.prescriptionDoctor = temp.prescriptionDoctor || '';
              this.info.prescriptionDoctorId = temp.creatorId || '';
              this.info.prescriptionHospital = temp.prescriptionHospital || '';
              this.info.hospitalDept = temp.hospitalDept || '';
              this.info.prescriptionNo = temp.prescriptionNo || '';
              this.info.prescriptionTime = temp.prescriptionTime || '';
              this.info.inquiryDoctor = temp.inquiryDoctor || '';
              this.info.inquiryHospital = temp.inquiryHospital || '';
              this.info.contact = temp.contact || '';
              this.info.patientName = temp.patientName || '';
              this.info.patientGender = temp.patientGender || '';
              this.info.patientAge = temp.patientAge || '';
              this.info.patientIdCard = temp.patientIdCard || '';
              this.info.patientPhone = temp.patientPhone || '';
              this.info.diseaseId = temp.diseaseId || '';
              this.info.additionalRemark = temp.additionalRemark || '';
              this.$emit('change', this.info);
              this.modalPre = false;
              this.btnConnectSta = false;
            } else {
              this.btnConnectSta = false;
              this.$Modal.warning({
                title: '温馨提示',
                content: `<p>${res.data.error}</p>`,
                okText: '我知道了',
              });
            }
          }).catch((err) => {
            this.btnConnectSta = false;
            utils.handleError(err);
          });
        }
      });
    },
    cancel() {
      this.modalPre = false;
    },
    connectDprescription() {
      this.modalPre = true;
    },
    handleFoucus() {
      this.isEmpty = false;
    },
    handleSelect(value) {
      this.selectStatus = true;
      this.doctorList.forEach((item) => {
        if (item.doctorCode == value) {
          this.$nextTick(() => {
            this.info.prescriptionDoctor = item.doctorName;
            this.info.prescriptionDoctorId = item.doctorCode;
            this.info.prescriptionHospital = item.hospitalName;
            this.info.hospitalDept = item.deptName;
            this.doctorList = [];
            this.$emit('change', this.info);
          });
        }
      });
    },
    handleSearch1: utils.debounce(
      function a(value) {
        if (this.selectStatus) {
          this.selectStatus = false;
          return;
        }
        if (!value) {
          this.isEmpty = false;
          return;
        }
        this.isEmpty = false;
        this.info.prescriptionDoctorId = '';
        this.$emit('change', this.info);
        this.doctorList = [];
        this.$store.commit('setDisableLoading', true);
        goods.getDoctorList({ param: value }).then((res) => {
          if (res.status === 200) {
            this.doctorList = res.data.data;
            if (!this.doctorList) {
              this.isEmpty = true;
            }
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
        });
      }, 2000,
    ),

    setRules(type) {
      this.salePrescription.patientIdCard
      && (this.salePrescription.patientIdCard[0].credentialsType = type);
    },
    setAdditionalRemark() {
      this.info.diseaseName = (this.diseaseList.length && this.info.diseaseId) ? this.diseaseList.find(item => item.id === this.info.diseaseId).diseaseName : '';
      if (this.info.diseaseName === '其他') {
        this.salePrescription.additionalRemark = [{ required: true, message: '请输入诊断补充说明', trigger: 'blur' }];
        this.$refs.additionalRemark.isRequired = true;
      } else {
        this.salePrescription.additionalRemark = [{ required: false }];
        this.diseaseList.length && this.$nextTick(() => {
          this.$refs.prescription.validateField('additionalRemark', () => {});
        });
        this.$refs.additionalRemark.isRequired = false;
        this.$refs.additionalRemark.validateMessage = '';
        this.$refs.additionalRemark.validateState = '';
      }
    },
    exchangeDictionary(arr, index) {
      return utils.exchangeDictionary(arr, index);
    },
    getBaseData() {
      return new Promise((resolve, reject) => {
        goods.GoodsDictionary().then((res) => {
          if (res.data.status === 200) {
            this.baseData.usageArr = [];
            this.baseData.frequencyArr = [];
            res.data.data.forEach((item) => {
              switch (item.dictionaryType) {
                case 14:
                  this.baseData.usageArr.push(item);
                  break;
                case 15:
                  this.baseData.frequencyArr.push(item);
                  break;

                default:
                  break;
              }
            });
            resolve();
          } else {
            this.$Message.error(res.data.error);
          }
        }).catch((err) => {
          utils.handleError(err);
          reject(err);
        });
      });
    },
    importPresription(data) {
      console.log(data);
      // let has = false;
      data.salePrescription.saleUsageList = [];
      this.info.saleUsageList.forEach((item, index) => {
        data.salePrescription.saleUsageList[index] = {};
        data.saleUsageList.forEach((subItem) => {
          if (subItem.goodsStoreId === item.goodsStoreId) {
            subItem.goodsCount = item.goodsCount;
            item = Object.assign(item, subItem);

            // data.salePrescription.saleUsageList[index] =  utils.deepClone(this.saleUsageList[index])
          }
        });
      });

      // this.info.saleUsageList = utils.deepClone(this.saleUsageList);

      data.salePrescription.id = this.info.id;
      data.salePrescription.saleUsageList = this.info.saleUsageList;
      this.info = data.salePrescription;
      this.isValidated && this.$nextTick(() => {
        this.validateForm();
      });
      this.$emit('change', this.info);
    },
    setSaleUsageList(list) {
      // console.log(list);
      list.forEach((item) => {
        item.medicationCycle || (item.medicationCycle = null);
        item.rebuyRemindDays || (item.rebuyRemindDays = null);
        this.info.saleUsageList.forEach((subItem) => {
          if (item.goodsStoreId === subItem.goodsStoreId) {
            delete subItem.goodsCount;
            item = Object.assign(item, subItem);
          }
        });
      });
      this.info.saleUsageList = utils.deepClone(list);

      this.$emit('change', this.info);
      this.showGoodsTable = false;
      this.$nextTick(() => {
        this.showGoodsTable = true;
      });
    },
    // setPart() {
    //   console.dir(this.$refs.prescriptionPart);
    //   const prescription = this.$refs.prescriptionPart.querySelectorAll('input');
    //   prescription.forEach((item) => {
    //     item.cardPart = 'prescription';
    //   });
    // },
    exchangePharmacistList(val, key) {
      console.log(val);
      this.pharmacistList.forEach((item) => {
        if (item.id === val) {
          this.info[key] = item.name;
        }
      });
    },
    validateForm() {
      this.info.allocater = utils.isMatchFilter(this.pharmacistList, this.info.allocater);
      this.info.reviewer = utils.isMatchFilter(this.pharmacistList, this.info.reviewer);
      return new Promise((resolve) => {
        let result = false;
        this.$refs.prescription.validate((valid) => {
          result = valid;
          const namelist = [];
          // 天猫的才进行复购提醒
          this.isTmall && result && this.info.saleUsageList.forEach((item) => {
            if (item.isPatientRebuy) { // 判定复购提醒增加必填
              (item.usageStartTime && item.rebuyRemindDays && item.medicationCycle) || (result = false);
              namelist.push(item.approvedDrugNames || item.approvedDrugName);
            }
          });
          this.isValidated = true;
          if (valid && !result) {
            this.$Message.error(`请在${namelist.join('、')}的商品行填写开始用药时间，用药周期和用药提醒天数`);
            return;
          }
          resolve(result);
        });
      });
    },
  },
  created() {
    if (this.able) {
      if (this.isContainDataDirectGoods) {
        this.salePrescription = {
          prescriptionHospital: [{
            required: true,
            message: '请输入处方医院',
            trigger: 'change',
          }],
          prescriptionDoctor: [{
            required: true,
            message: '请输入处方医生',
            trigger: 'change',
          }],
          diseaseId: [{
            required: true,
            message: '请选择诊断说明',
            trigger: 'change',
            type: 'number',
          }],
          allocater: [{
            required: true,
            message: '请输入调配人',
            trigger: 'change',
            type: 'number',
          }],
          reviewer: [{
            required: true,
            message: '请输入复核人',
            trigger: 'change',
            type: 'number',
          }],
        };
      } else {
        this.salePrescription = {
          allocater: [{
            required: true,
            message: '请输入调配人',
            trigger: 'change',
            type: 'number',
          }],
          reviewer: [{
            required: true,
            message: '请输入复核人',
            trigger: 'change',
            type: 'number',
          }],
        };
      }
    } else if (this.isPrescription) {
      this.salePrescription = {
        allocater: [{
          required: true,
          message: '请输入调配人',
          trigger: 'change',
          type: 'number',
        }],
        reviewer: [{
          required: true,
          message: '请输入复核人',
          trigger: 'change',
          type: 'number',
        }],
      };
    } else {
      this.salePrescription = {};
    }
    if (this.isEdit) { // 天猫和杰特贝林加上这两个校验
      this.$set(this.salePrescription, 'patientIdCard',
        [
          { validator: utils.validate.credentialsValidate, trigger: 'blur' },
        ]);
      this.$set(this.salePrescription, 'patientPhone',
        [
          {
            validator: utils.validate.phoneValidator,
            message: '请输入正确联系方式',
            trigger: 'blur',
          },
        ]);
    }
  },
  mounted() {
    this.getBaseData().then(() => {
      // this.setPart();
      this.info = this.data;
      this.publicParams.editList.forEach((item) => {
        !this.data[item] && this.JTBLEditList.push(item);
      });
      // this.info.saleUsageList = this.saleUsageList;
      this.isValidated = false;
      this.able && this.setAdditionalRemark();
      // this.notPrescription && this.setAdditionalRemark()待定
    }).catch((err) => {
      utils.handleError(err);
    });
  },
};

</script>
<style scoped lang="less">
.btnCon {
  width: 100%;
  display: flex;
  justify-content: center;
}
.prescription-page {
  margin-top: 20px;
  width: 50%;
}
.image-container {
  position: absolute;
  right: 0;
  top: 30px;
  width: 50%;
  height: 510px;
}
  .goodsTable {

    // overflow: auto;
    // overflow-x: auto;
    // border: 1px solid #eee;
    table {
      width: 70vw;
      border-collapse: collapse;
      border: 1px solid #eee;

      tr {
        height: 46px
      }

      td {
        border: 1px solid #dedede;
        min-width: 83px;
        padding: 0 13px;

      }

      thead {
        background: #fafafa;
        font-weight: 500
      }
    }

    .detail {
      background: #F5F5F5;
      padding: 12px 24px;

      >td {
        padding-right: 0;

        >div {

          display: flex;
          flex-wrap: wrap
        }
      }

      .detailItem {
        margin-right: 30px
      }
    }
  }
.test1 {
  min-height: 0;
  max-height: 100px;
  position: relative;
  overflow: auto;
}
/deep/ .ivu-select-dropdown {
  padding: 0;
}
/deep/ .ivu-row{
  margin: 16px 0;
}
.nodata {
  color: #9a9a9a;
  font-size: 14px;
  padding: 4px 0 4px 4px;
}
#app .ivu-radio-wrapper {
  margin-right: 20px;
}
.editRow{
  display: flex;
  justify-content: space-between;
  // margin-bottom: 8px;
  >*:first-child{
    width: 90%;
    >*{

      width: 33%;
    }
  }
}
</style>
